import React from 'react';

const EventsTab = () => {
    return (
        <div className="text-center py-16">
            <i className="fa fa-calendar-check text-green-400 text-6xl mb-4"></i>
            <h3 className='font-bold text-2xl'>Event Registration</h3>
            <p className=''>Browse and register for upcoming events.</p>
            <span className='text-green-600 font-bold text-sm uppercase underline underline-offset-4'>Coming Soon</span>
        </div>
    );
};

export default EventsTab;
